export default "__VITE_ASSET__c5a6c084__"